import { render, staticRenderFns } from "./itemListClient.vue?vue&type=template&id=32a911aa&scoped=true&"
import script from "./itemListClient.vue?vue&type=script&lang=js&"
export * from "./itemListClient.vue?vue&type=script&lang=js&"
import style0 from "./itemListClient.vue?vue&type=style&index=0&id=32a911aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a911aa",
  null
  
)

export default component.exports